import {
  ActionHandler,
  BaseSeqState,
  PickMainState,
  GenerateActionTypes,
  // BLC_STATUS_TYPE,
  // MasterMapOptions,
} from "../../../../src/react-lib/apps/HISV3/common/CommonInterface";
import WasmController from "@/react-lib/frameworks/WasmController";
import { UploadBeforeHandler, UploadBeforeReturn, UploadInfo } from "suneditor-react/dist/types/upload";
import { BroadcastDataFirebase, BroadcastFirebaseData, CreatedBroadcastData, PatientByLeafList, PostCalculateCredit, PostCalculateCreditParams, UpdateContentParams, UpdatedUserFirebase } from "./MeFormType";

/*================================ SERIALIZERS ==============================*/

import PublishedDiagRuleNodeSerializer from "@/issara-sdk/types/PublishedDiagRuleNodeSerializer_apps_PRX";
import BroadcastPostSerializer from "@/issara-sdk/types/BroadcastPostSerializer_apps_PRX";
import DivisionSerializer from "@/issara-sdk/types/DivisionSerializer_core";
import EmployeeSerializer from "@/issara-sdk/types/EmployeeSerializer_users";
import UserProfileSerializer from "@/issara-sdk/types/UserProfileSerializer_users";
import BroadcastPostActionLogSerializer from 'issara-sdk/types/BroadcastPostActionLogSerializer_apps_PRX';
import PublishedDiagRuleWithNodeSerializer from "@/issara-sdk/types/PublishedDiagRuleWithNodeSerializer_apps_PRX";
import PublishedDiagRuleNodeMemberSerializer from "@/issara-sdk/types/PublishedDiagRuleNodeMemberSerializer_apps_PRX";
import DiagRuleSerializer from "@/issara-sdk/types/DiagRuleSerializer_apps_PRX";
import ProxyPatientSerializer from "@/issara-sdk/types/ProxyPatientSerializer_apps_PRX";

/*================================ ACTIONS & CONSTANTS ==============================*/

export const ACTIONS = {
  // * --- Common
  // FETCH: "FETCH",
  ACTION_BROADCAST: "ACTION_BROADCAST",

  // * --- Member Group Tab
  GET_MEMBER_GROUP_LIST: "GET_MEMBER_GROUP_LIST",
  GET_MEMBER_NODE_LIST: "GET_MEMBER_NODE_LIST",
  ACTION_MEMBER_NODE: "ACTION_MEMBER_NODE",

  // * --- Broadcast List Tab
  GET_BROADCAST_POST_LIST: "GET_BROADCAST_POST_LIST",
  SELECT_BROADCAST: "SELECT_BROADCAST",
  POST_BROADCAST: "POST_BROADCAST",
  UPDATE_BROADCAST: "UPDATE_BROADCAST",
  GET_POST_CALCULATE_CREDIT: "GET_POST_CALCULATE_CREDIT",
  GET_PATIENT_BY_LEAF: "GET_PATIENT_BY_LEAF",
  GET_UPDATED_BY_USER_FIREBASE: "GET_UPDATED_BY_USER_FIREBASE",

  // * --- Insights

  // * --- Approval
  GET_BROADCAST_POST_DETAIL: "GET_BROADCAST_POST_DETAIL",
  GET_DIVISION_LIST: "GET_DIVISION_LIST",
  GET_DIVISION_DETAIL: "GET_DIVISION_DETAIL",
  GET_BROADCAST_LOG: "GET_BROADCAST_LOG",
  DUPLICATE_BROADCAST: "DUPLICATE_BROADCAST",

  // * --- Firebase Handlers
  ADD_CONTENT: "ADD_CONTENT",
  GET_CONTENT: "GET_CONTENT",
  UPDATE_CONTENT: "UPDATE_CONTENT",
  SAVE_CONTENT: "SAVE_CONTENT",
  DELETE_CONTENT: "DELETE_CONTENT"
} as const;

export const SEQUENCE_NAME = "MeCast" as const;
export const MAIN_CARD_NAME = "CardMeCastList" as const;
// export const BROADCAST_CARD_NAME = "CardMeFormBroadcast" as const; // --- ยืมมาจาก MeFormType ก็ได้

/*================================ STATE ==============================*/

export type State = {
  MeCastSequence: Partial<{
    sequenceIndex: "Start" | "Action" | null;

    // * --- Member Group Tab
    memberGroupTab: MeCastMemberGroupTab;

    // * --- Broadcast List Tab
    broadcastListTab: MeCastBroadcastListTab;

    // * --- Insights Tab
    insightsTab: MeCastInsightsTab;

    // * --- Firebase Handler
    firebaseData: BroadcastFirebaseData;

    // * --- Common
    commonData: MeCastCommon;

    broadcastApprovalTab: MeCastBroadcastApprovalTab;
  }> | null;
};

export type MeCastCommon = Partial<{
  pdrNodeList: PublishedDiagRuleNodeSerializer[];
  diagFormList: DiagRuleSerializer[];
}>;

export type MeCastMemberGroupTab = Partial<{
  memberGroupList: MemberGroupListResponse;
  memberNodeList: PublishedDiagRuleNodeMemberSerializer[];
  patientDetailMap: PatientDetailMap;
}>;

export type MeCastBroadcastListTab = Partial<{
  broadcastList: BroadcastListResponse;
  selectedPdrNode: PublishedDiagRuleNodeSerializer;
  selectedBroadcast: BroadcastPostSerializer;
  postCalculateCredit: PostCalculateCredit;
  broadcastDetail: BroadcastPostSerializer;
  createdByUser: EmployeeSerializer;
  updatedByUserFirebase: UpdatedUserFirebase;
  patientByLeafList: PatientByLeafList;
}>;

export type MeCastInsightsTab = Partial<{}>;

export type MeCastBroadcastApprovalTab = Partial<{
  divisionDetail: DivisionSerializer;
  divisionList: DivisionListResponse;
  selectedBroadcastLog: BroadcastPostActionLogSerializer[];
  selectedBroadcast: BroadcastPostSerializer;
}>;

export type DivisionListResponse = {
  items: DivisionSerializer[];
  total: number;
};

export type BroadcastListResponse = {
  activePage: number;
  items: BroadcastPostSerializer[];
  total: number;
};

export type ParsedContent = {
  previews_text: string;
  previews_picture: string[];
  previews_video: string[];
};

export type MemberGroupListResponse = {
  activePage: number;
  items: PublishedDiagRuleWithNodeSerializer[];
  total: number;
};

export type MemberGroupListNodesItem = {
  node: number;
  node_name: string;
  members: NodesMember[];
  total_member: number;
};

export type NodesMember = {
  patient: number
  diag_form_answer_path: number
  diag_form_answer_path_active: boolean
  published_diag_rule: number
  published_diag_rule_node_id: number
  published_diag_rule_node: number
  user: number
};

export type SelectedMemberNode = {
  group: PublishedDiagRuleWithNodeSerializer;
  node: MemberGroupListNodesItem;
};

export type PatientDetailMap = Record<number, ProxyPatientSerializer>;

export type BroadcastMode = "CREATE" | "EDIT" | "VIEW";

export type ActionPostBroadcast = "APPROVE" | "UNAPPROVE" | "REJECT" | "DRAFT" | "EDIT" | "CANCEL";

export type BroadcastAction = "VIEW" | "EDIT" | "DUPLICATE" | "CANCEL" | "CANCEL_REVIEW";

export type PickedState = PickMainState<
  | "buttonLoadCheck"
  | "errorMessage"
  | "successMessage" 
  | "loadingStatus" 
  | "django" 
  | "BillingCreditWallet" 
  | "userProfile"
  | "selectedDivision"
>;

export type Event =
  | { message: "RunSequence"; params: Record<string, unknown> }
  | { message: "GetMasterData"; params: Record<string, unknown> };

export type Data = Partial<{
  division: number;
  userProfile?: UserProfileSerializer & { full_name: string };
}>;

export type Actions = typeof ACTIONS;

export type SequenceName = typeof SEQUENCE_NAME;

export type SeqState = BaseSeqState<SequenceName>
  & Partial<{ broadcastParams: BroadcastPostParams; memberGroupParams: MemberGroupListParams }>;

/*================================ PARAMS ==============================*/

// export type FetchParams = Partial<{}>;

export type BroadcastParams = Partial<{
  publishedDiagRuleNodes: any;
  division: number;
  broadcastType: string;
  receiverType: string;
  scheduleBroadcastedStartDate: any;
  scheduleBroadcastedEndDate: any;
  statuses: any;
  broadcastId: number;
  groupName: string;
  sendReviewedStartDate: any;
  sendReviewedEndDate: any;
}>;

export type BroadcastPostParams = Partial<{
  published_diag_rule_nodes: number[];
  division: number;
  broadcast_type: BroadcastPostSerializer["broadcast_type"];
  receiver_type: BroadcastPostSerializer["receiver_type"];
  schedule_broadcasted_start_date: string;
  schedule_broadcasted_end_date: string;
  broadcasted_start_date: string;
  broadcasted_end_date: string;
  reviewed_start_date: string;
  reviewed_end_date: string;
  send_reviewed_start_date: string;
  sent_reviewed_end_date: string;
  broadcast_id: string;
  statuses: BroadcastPostSerializer["status"][];
  // --- extra
  group_name: string;
}>;

export type BroadcastPostApiParams = Omit<BroadcastPostParams, "group_name">;

export type divisionDetailParams = Partial<{
  id: number;
}>;

export type ApproveBroadcastPostParams = {
  broadcastPostId: number;
  broadcastParams?: BroadcastPostParams;
  onSuccess?: (duplicatedRow: BroadcastPostSerializer) => void;
};

export type SelectBroadcastParams = {
  pdrNodeId: number;
};

export type BroadcastApprovalParams = 
  ApproveBroadcastPostParams &
  { actionParams: ActionBroadcastApprovalParams };

export type ActionBroadcastApprovalParams = {
  action: ActionPostBroadcast;
  remark?: string; // สำหรับ Reject
};

export type ResolveBroadcastParamsResult = {
  params: BroadcastPostApiParams;
  error?: any;
};

export type PatientByLeafParams = {
  pdrNodeId: number;
  nodeId: number;
  publishedDiagRuleId: number;
};

export type MemberGroupListParams = Partial<{
  published_diag_rule: number;
  diag_rule_name: string;
  published_diag_rule_node: number;
  node_name: string;
}>;

export type MemberGroupNodeParams = Partial<{
  hn: string;
  name: string;
  active: boolean;
}>;

export type MemberGroupNodeItem = {
  id: number;
  active: boolean;
};

export type MemberGroupNodeActionParams = {
  items: MemberGroupNodeItem[];
};

export type ActionPayloadMap = {
  // [ACTIONS.FETCH]: FetchParams;
  // * --- Common
  [ACTIONS.ACTION_BROADCAST]: BroadcastApprovalParams;

  // * --- Member Group Tab
  [ACTIONS.GET_MEMBER_GROUP_LIST]: { filter: MemberGroupListParams; activePage?: number };
  [ACTIONS.GET_MEMBER_NODE_LIST]: { pdrNodeId: number; filter: MemberGroupNodeParams; };
  [ACTIONS.ACTION_MEMBER_NODE]: { pdrNodeId: number; filter: MemberGroupNodeParams; data: MemberGroupNodeActionParams; onSuccess?: () => void };

  // * --- Broadcast List Tab
  [ACTIONS.GET_BROADCAST_POST_LIST]: { broadcastParams: BroadcastPostParams; activePage?: number };
  [ACTIONS.SELECT_BROADCAST]: SelectBroadcastParams;
  [ACTIONS.POST_BROADCAST]: { createdData: CreatedBroadcastData };
  [ACTIONS.UPDATE_BROADCAST]: { createdData: CreatedBroadcastData; broadcastPostId: number };
  [ACTIONS.GET_POST_CALCULATE_CREDIT]: { calculateParams: PostCalculateCreditParams };
  [ACTIONS.GET_PATIENT_BY_LEAF]: PatientByLeafParams;
  [ACTIONS.GET_UPDATED_BY_USER_FIREBASE]: { firebaseId: string };

  // * --- Insights Tab

  // * --- Broadcast Approval Tab
  [ACTIONS.GET_DIVISION_DETAIL]: divisionDetailParams;
  [ACTIONS.GET_BROADCAST_LOG]: ApproveBroadcastPostParams;
  [ACTIONS.GET_BROADCAST_POST_DETAIL]: ApproveBroadcastPostParams;
  [ACTIONS.DUPLICATE_BROADCAST]: ApproveBroadcastPostParams;

  // * --- Firebase 
  [ACTIONS.GET_CONTENT]: { selectedBroadcast: BroadcastPostSerializer };
  [ACTIONS.UPDATE_CONTENT]: UpdateContentParams;
};

export type ActionTypes = GenerateActionTypes<
  Actions,
  ActionPayloadMap,
  SequenceName,
  PickedState & State
>;

export type LoadingKey = keyof PickedState["loadingStatus"];

export type ButtonLoadCheckKey = keyof PickedState["buttonLoadCheck"];

export type ErrorMessageKey = keyof PickedState["errorMessage"];

export type SuccessMessageKey = keyof PickedState["successMessage"];

export type ActionType = ActionTypes["ActionType"];

export type RunSequence = ActionTypes["RunSequence"];

export type SetProp = ActionTypes["SetProp"];

export type OnEvent = ActionTypes["OnEvent"];

export type Controller = WasmController<PickedState & State, Event, Data, {}>;

export type Params<A extends ActionType["action"]> = ActionTypes["Params"][A];

export type Handler<P = any, R = any> = ActionHandler<PickedState & State, Event, Data, P, R>;

/*================================ BROADCAST EDITOR ==============================*/

export type BroadcastEditorContext = {
  // --- init data
  broadcast?: BroadcastPostSerializer;
  firebase?: BroadcastDataFirebase;

  // --- from Form (optional)
  initPdrNode?: PublishedDiagRuleNodeSerializer | null;
  patientByLeafList?: PatientByLeafList;
  pdrNodeList?: PublishedDiagRuleNodeSerializer[];

  // --- Infra
  postCalculateCredit?: PostCalculateCredit;
  updatedByUserFirebase?: UpdatedUserFirebase;
};

type UploadImageParams = {
  targetImgElement: HTMLImageElement,
  index: number,
  contentAction: "create" | "update" | "delete",
  imageInfo: UploadInfo<HTMLImageElement>,
  remainingFilesCount: number
};

type UploadImageBeforeParams = {
  files: File[],
  info: object,
  uploadHandler: UploadBeforeHandler
};


export type BroadcastEditorActions = {
  updateContent: (content: string) => Promise<void>;
  uploadImage: (props: UploadImageParams) => Promise<void>;
  uploadImageBefore: (props: UploadImageBeforeParams) => UploadBeforeReturn | undefined;
  uploadImageError: (errorMessage: string, result: any) => void;
  resizeEditor: (height: number, prevHeight: number) => void;

  // domain side-effects
  calculateCredit: (params: PostCalculateCreditParams) => void;
  onSubmit: (data: CreatedBroadcastData) => void;
  
  // infra fetch
  getPatientByLeaf?: (pdrNodeId: number, nodeId: number, pdrId: number) => void;
};

export type UseBroadcastEditor = {
  mode: BroadcastMode;
  context: BroadcastEditorContext;
  actions: BroadcastEditorActions;
};

/*================================ CONSTANTS ==============================*/

//* สำหรับ Init Broadcast List Filter (at CardMecastMain)
export const INIT_BROADCAST_LIST_FILTER: BroadcastPostParams = {
  statuses: ["PENDING_REVIEW", "REVIEWED", "DRAFTED"],
  broadcast_id: "",
  group_name: "",
  broadcast_type: undefined,
  division: undefined,
  schedule_broadcasted_start_date: "",
  schedule_broadcasted_end_date: ""
};

//* สำหรับ Init Broadcast Approval Filter (at CardMeCastBroadcastApproval)
export const INIT_BROADCAST_APPROVAL_FILTER: BroadcastPostParams = {
  statuses: ["PENDING_REVIEW"],
  broadcast_id: "",
  group_name: "",
  broadcast_type: undefined,
  division: undefined,
  schedule_broadcasted_start_date: "",
  schedule_broadcasted_end_date: "",
  send_reviewed_start_date: "",
  sent_reviewed_end_date: ""
};

//* สำหรับแสดงใน Status Filter (at CardMeCastList)
export const STATUS_BROADCAST_LIST_OPTIONS: { key: string; text: string; values: BroadcastPostSerializer["status"][] }[] = [
  { key: "schedule", text: "Schedule", values: ["PENDING_REVIEW", "REVIEWED"] },
  { key: "draft", text: "Draft", values: ["DRAFTED"] },
  { key: "sent", text: "Sent", values: ["BROADCASTED"] },
  { key: "fail", text: "Rejected & Failed", values: ["REVIEW_REJECTED"] },
  { key: "canceled", text: "Canceled", values: ["CANCELED"] },
  // { key: "pending", text: "Pending", value: "PENDING_REVIEW" },
];

//* สำหรับแสดงใน Status Filter (at CardMeCastBroadcastApproval)
export const STATUS_BROADCAST_APPROVAL_OPTIONS: { key: string; text: string; value: BroadcastPostSerializer["status"] }[] = [
  { key: "pending", text: "Pending Review", value: "PENDING_REVIEW" },
  { key: "approved", text: "Approved", value: "REVIEWED" },
  { key: "rejected", text: "Rejected", value: "REVIEW_REJECTED" },
];

//* สำหรับแสดง Options ใน Broadcast Type Filter (at CardMeCastList / CardMeCastBroadcastApproval)
export const BROADCAST_TYPE_OPTIONS: { key: string; text: string; value: BroadcastPostSerializer["broadcast_type"] }[] = [
  { key: "schedule", text: "Schedule", value: "SCHEDULE" },
  { key: "instant", text: "Sent Instantly", value: "INSTANTLY" },
];

//* สำหรับกำหนด Actions ต่าง ๆ ให้กับ Broadcast ตาม Status ต่าง ๆ (at CardMeCastList)
export const ACTIONS_BY_STATUS: Record<
  BroadcastPostSerializer["status"],
  BroadcastAction[]
> = {
  PENDING_REVIEW: ["VIEW", "EDIT", "DUPLICATE", "CANCEL_REVIEW"],
  CANCELED: ["VIEW", "DUPLICATE"],
  DRAFTED: ["VIEW", "EDIT", "DUPLICATE", "CANCEL"],
  REVIEWED: ["VIEW", "EDIT", "DUPLICATE", "CANCEL"],
  BROADCASTED: ["VIEW", "DUPLICATE"],
  REVIEW_REJECTED: ["VIEW", "EDIT", "DUPLICATE"]
};

//* สำหรับแสดง Header บน Popup Action
export const HEADER_ACTION_MOD: Record<ActionPostBroadcast, string> = {
  "APPROVE": "Broadcast Approval",
  "REJECT": "Broadcast Rejection",
  "UNAPPROVE": "Broadcast Unapproval",
  "CANCEL": "",
  "DRAFT": "",
  "EDIT": "",
};

